
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

const EmptyAlertsState: React.FC = () => {
  return (
    <Card>
      <CardContent className="p-6 text-center">
        <p className="text-muted-foreground">No maintenance alerts match your criteria</p>
      </CardContent>
    </Card>
  );
};

export default EmptyAlertsState;
